import React from 'react';
import styles from './Divider.module.scss';

const Divider = ({length = 60, vertical = false, className = ''}) => {
    return (
        <div className={`${styles.divider} ${vertical ? styles.vertical : styles.horizontal} ${className}`} style={vertical ? {height: length} : {width: length}} />
    )
}

export default Divider;